import { keyframes } from "@emotion/react";
import { 
  generateProductSeoUrl, 
  generateHeaderSeoUrl, 
  generateFooterCategorySeoUrl 
} from './utils/seoUrlGenerator';

export const emailReg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const passwordValidate = {
  hasUpperCase: (value) =>
    /[A-Z]/.test(value) ||
    "Password must contain at least one uppercase letter",
  hasLowerCase: (value) =>
    /[a-z]/.test(value) ||
    "Password must contain at least one lowercase letter",
  hasNumber: (value) =>
    /\d/.test(value) || "Password must contain at least one number",
  hasSpecialChar: (value) =>
    /[\W_]/.test(value) ||
    "Password must contain at least one special character",
};
export const getCurrentColor = (theme, black, white) => {
  return theme === "dark" ? white : black;
};
export const comparisonCheckedFilter = (
  alt_name,
  flag,
  brand_id,
  vendor_id,
  name,
) => ((alt_name || flag || brand_id || vendor_id || name) + "").toLowerCase();
export const headerLink = (category, name, cookie) =>
  // eslint-disable-next-line
  `/${category.replace("/(?:s|-)?ammo/gi,", "").toLowerCase()}/${encodeURIComponent(name && name.replace("/", " "))}?wc=${category.replace(/ Ammo|-ammo|ammo/g, "").toLowerCase()}&caliber=${encodeURIComponent(name)}&page=1&sort_by=landed_cpr${cookie ? `&zip=${cookie}` : ""}`;
export const calibersLink = (path, caliber, categoryName, cookie) =>
  `${path}/${encodeURIComponent(caliber && caliber.replace("/", " "))}?wc=${categoryName.replace(/ Ammo|-ammo|ammo/g, "").toLowerCase()}&caliber=${encodeURIComponent(caliber)}&page=1&sort_by=landed_cpr${cookie ? `&zip=${cookie}` : ""}`;
export const productGroupLink = (pgId, cookie) =>
  `product/${pgId}?pgId=${pgId}&page=1&per_page=12&sort_by=landed_cpr${cookie ? `&zip=${cookie}` : ""}`;

// SEO URL generation functions (new)
export const generateSeoProductGroupLink = (productData, facetMappings, cookie) => {
  return generateProductSeoUrl(productData, facetMappings, cookie);
};

export const generateSeoHeaderLink = (category, name, facetMappings, cookie) => {
  return generateHeaderSeoUrl(category, name, facetMappings, cookie);
};

export const generateSeoCategoryLink = (categoryName, facetMappings) => {
  return generateFooterCategorySeoUrl(categoryName, facetMappings);
};

export const offsetTopStatus = (value) => value < 250;

export const bounceY = keyframes`
0%, 100% { transform: translateY(0); }
50% { transform: translateY(4px); }
`;

export const pulse = keyframes`
0%, 100% {
  opacity: 1;
}
50% {
  opacity: 0.5;
}
`;
